import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiToolbar-gutters": {
      marginRight: "0 !important",
      backgroundColor: theme.palette.toolBarBg,
    },
  },
  logo: {
    paddingTop: "28px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  large: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  toolbar: {
    backgroundColor: theme.palette.toolbarBg,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
    paddingLeft: 0,
    paddingRight: 0,
  },
  links: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    color: theme.palette.primary.main,
  },
  usernameSection: {
    minHeight: "64px !important",
    flex: "0 1 !important",
    display: "flex",
    flexDirection: "flex-start",
    alignItems: "center",
    borderRadius: "0px !important",
    "& .MuiIconButton-root": { borderRadius: 0 },
    "& .MuiButtonBase-root": {
      // "&:hover": {
      //   backgroundColor: "transparent",
      // },
    },
    "& .MuiListItemIcon-root": {
      minWidth: "30px !important",
    },
  },
  username: {
    color: "white",
  },
  arrowDropDown: {
    color: "white",
  },
  newMuiPaper: {
    shadow: "none",
  },
  List: {
    color: theme.palette.mainText,
    backgroundColor: "inherit",
    marginRight: "20px",
    marginLeft: "10px",
  },
  logoTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "24px",
  },
  onlineCircle: {
    backgroundColor: "green",
    borderRadius: "50%",
    width: "10px !important",
    height: "10px !important",
  },
}));

export default useStyles;
